
export const MOCK_SPACES: any[] = [
    { id: 'sws-emerg', short_name: 'SWSemerg', name: 'SWS - Emergency Medicine', list_member_names: false },
    { id: 'is-medical', short_name: 'ISmedical', name: 'IS - General Medicine', billing_consent: true, list_member_names: true },
    { id: 'syd-surgery', short_name: 'SYDsurgery', name: 'SYD - Surgery' },
    { id: 'wnsw-childfam', short_name: 'WNSWchildfam', name: 'WNSW - Child and Family Health Services', billing_consent: true },
    { id: 'murr-mh', short_name: 'MURRmh', name: 'MURR - Mental Health', billing_consent: true },
    { id: 'nbm-commh', short_name: 'NBMcommh', name: 'NBM - Community Health', billing_consent: true },
    { id: 'nsw-icu', short_name: 'NSWicu', name: 'NSH - Intensive Care' },
    { id: 'ws-interp', short_name: 'WSinterp', name: 'WS - Interpreters' }
]
